export const INTERSECTION_OBSERVER_THRESHOLD = 0;

export const MAX_AMOUNT_VISIBLE_OPTIONS = 50;

export const DEBOUNCE_DELAY_MS = 500;

export const RatesheetStatus = {
  IDLE: 'idle',
  PENDING: 'pending',
  FULFILLED: 'fulfilled',
  REJECTED: 'rejected',
};
